import { TireSeason } from '@navio/nsdk';
import type { CarWheelSeasonValue } from 'noddi-types';

import { NumericValueToTireSeason } from '../wheel/wheel';

export const TIRE_SEASON_ICON = {
  [TireSeason.SUMMER]: 'Sun',
  [TireSeason.WINTER]: 'Snowflake',
  [TireSeason.ALL_SEASON]: 'CloudRain'
} as const;

export const resolveTireSeason = (season: string | number): TireSeason | undefined => {
  if (typeof season === 'number') {
    return NumericValueToTireSeason[season as CarWheelSeasonValue] ?? undefined;
  }

  const normalized = season
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
  if (normalized === 'ALLSEASON') {
    return TireSeason.ALL_SEASON;
  }
  if (normalized === TireSeason.SUMMER || normalized === TireSeason.WINTER || normalized === TireSeason.ALL_SEASON) {
    return normalized;
  }
  return undefined;
};
